// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"4e0c5b44","211":"63be746c","453":"d53303d2","947":"21233868"}[chunkId] + ".chunk.js";
};